/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignedContentCreateResponse,
  AssignedContentIndexResponse,
  AssignedContentUpdateResponse,
  ContentBulkUpgrade,
  ContentCreate,
  ContentCreate1,
  ContentInCompanySpaceBulkUpgradeResponse,
  ContentInCompanySpaceCreateResponse,
  ContentInCompanySpaceIndexResponse,
  ContentInCompanySpaceShowResponse,
  ContentInCompanySpaceUpdateResponse,
  ContentInCompanySpaceUpgradeResponse,
  ContentParticipationIndexResponse,
  ContentParticipationReassignResponse,
  ContentParticipationShowResponse,
  ContentReassign,
  ContentUpdate,
  ContentUpdate1,
} from '../models';
import {
    AssignedContentCreateResponseFromJSON,
    AssignedContentCreateResponseToJSON,
    AssignedContentIndexResponseFromJSON,
    AssignedContentIndexResponseToJSON,
    AssignedContentUpdateResponseFromJSON,
    AssignedContentUpdateResponseToJSON,
    ContentBulkUpgradeFromJSON,
    ContentBulkUpgradeToJSON,
    ContentCreateFromJSON,
    ContentCreateToJSON,
    ContentCreate1FromJSON,
    ContentCreate1ToJSON,
    ContentInCompanySpaceBulkUpgradeResponseFromJSON,
    ContentInCompanySpaceBulkUpgradeResponseToJSON,
    ContentInCompanySpaceCreateResponseFromJSON,
    ContentInCompanySpaceCreateResponseToJSON,
    ContentInCompanySpaceIndexResponseFromJSON,
    ContentInCompanySpaceIndexResponseToJSON,
    ContentInCompanySpaceShowResponseFromJSON,
    ContentInCompanySpaceShowResponseToJSON,
    ContentInCompanySpaceUpdateResponseFromJSON,
    ContentInCompanySpaceUpdateResponseToJSON,
    ContentInCompanySpaceUpgradeResponseFromJSON,
    ContentInCompanySpaceUpgradeResponseToJSON,
    ContentParticipationIndexResponseFromJSON,
    ContentParticipationIndexResponseToJSON,
    ContentParticipationReassignResponseFromJSON,
    ContentParticipationReassignResponseToJSON,
    ContentParticipationShowResponseFromJSON,
    ContentParticipationShowResponseToJSON,
    ContentReassignFromJSON,
    ContentReassignToJSON,
    ContentUpdateFromJSON,
    ContentUpdateToJSON,
    ContentUpdate1FromJSON,
    ContentUpdate1ToJSON,
} from '../models';

export interface CompanySpacesContentBulkUpgradePostRequest {
    body?: ContentBulkUpgrade;
}

export interface CompanySpacesContentGetRequest {
    term?: string;
    name?: string;
    ownershipType?: CompanySpacesContentGetOwnershipTypeEnum;
    contentTypes?: CompanySpacesContentGetContentTypesEnum;
    authorIds?: Array<number>;
    authorId?: number;
    publishedAt?: string;
    upgradable?: boolean;
    sort?: string;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesContentIdDeleteRequest {
    id: string;
}

export interface CompanySpacesContentIdGetRequest {
    id: string;
}

export interface CompanySpacesContentIdPutRequest {
    id: string;
    body?: ContentUpdate1;
}

export interface CompanySpacesContentIdUpgradePutRequest {
    id: string;
    body?: object;
}

export interface CompanySpacesContentPostRequest {
    body?: ContentCreate1;
}

export interface CompanySpacesUserGroupsUserGroupIdContentGetRequest {
    userGroupId: number;
}

export interface CompanySpacesUserGroupsUserGroupIdContentIdDeleteRequest {
    userGroupId: number;
    id: string;
}

export interface CompanySpacesUserGroupsUserGroupIdContentIdPostRequest {
    userGroupId: number;
    id: string;
    body?: ContentCreate;
}

export interface CompanySpacesUserGroupsUserGroupIdContentIdPutRequest {
    userGroupId: number;
    id: string;
    body?: ContentUpdate;
}

export interface CompanySpacesUsersUserIdContentGetRequest {
    userId: number;
    paginatesPer?: number;
    filterByState?: Array<string>;
}

export interface CompanySpacesUsersUserIdContentIdGetRequest {
    userId: number;
    id: string;
}

export interface CompanySpacesUsersUserIdContentIdReassignPostRequest {
    userId: number;
    id: string;
    body?: ContentReassign;
}

/**
 * 
 */
export class ContentApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesContentBulkUpgradePostRaw(requestParameters: CompanySpacesContentBulkUpgradePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentInCompanySpaceBulkUpgradeResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/content/bulk_upgrade`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContentBulkUpgradeToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentInCompanySpaceBulkUpgradeResponseFromJSON));
    }

    /**
     */
    async companySpacesContentBulkUpgradePost(requestParameters: CompanySpacesContentBulkUpgradePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentInCompanySpaceBulkUpgradeResponse>> {
        const response = await this.companySpacesContentBulkUpgradePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesContentGetRaw(requestParameters: CompanySpacesContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentInCompanySpaceIndexResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.term !== undefined) {
            queryParameters['term'] = requestParameters.term;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.ownershipType !== undefined) {
            queryParameters['ownership_type'] = requestParameters.ownershipType;
        }

        if (requestParameters.contentTypes !== undefined) {
            queryParameters['content_types'] = requestParameters.contentTypes;
        }

        if (requestParameters.authorIds) {
            queryParameters['author_ids'] = requestParameters.authorIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.authorId !== undefined) {
            queryParameters['author_id'] = requestParameters.authorId;
        }

        if (requestParameters.publishedAt !== undefined) {
            queryParameters['published_at'] = requestParameters.publishedAt;
        }

        if (requestParameters.upgradable !== undefined) {
            queryParameters['upgradable'] = requestParameters.upgradable;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/content`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentInCompanySpaceIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesContentGet(requestParameters: CompanySpacesContentGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentInCompanySpaceIndexResponse>> {
        const response = await this.companySpacesContentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesContentIdDeleteRaw(requestParameters: CompanySpacesContentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesContentIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/content/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesContentIdDelete(requestParameters: CompanySpacesContentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesContentIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesContentIdGetRaw(requestParameters: CompanySpacesContentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentInCompanySpaceShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesContentIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/content/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentInCompanySpaceShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesContentIdGet(requestParameters: CompanySpacesContentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentInCompanySpaceShowResponse> {
        const response = await this.companySpacesContentIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesContentIdPutRaw(requestParameters: CompanySpacesContentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentInCompanySpaceUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesContentIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/content/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ContentUpdate1ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentInCompanySpaceUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesContentIdPut(requestParameters: CompanySpacesContentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentInCompanySpaceUpdateResponse> {
        const response = await this.companySpacesContentIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesContentIdUpgradePutRaw(requestParameters: CompanySpacesContentIdUpgradePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentInCompanySpaceUpgradeResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesContentIdUpgradePut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/content/{id}/upgrade`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentInCompanySpaceUpgradeResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesContentIdUpgradePut(requestParameters: CompanySpacesContentIdUpgradePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentInCompanySpaceUpgradeResponse> {
        const response = await this.companySpacesContentIdUpgradePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesContentPostRaw(requestParameters: CompanySpacesContentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentInCompanySpaceCreateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/content`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContentCreate1ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentInCompanySpaceCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesContentPost(requestParameters: CompanySpacesContentPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentInCompanySpaceCreateResponse> {
        const response = await this.companySpacesContentPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdContentGetRaw(requestParameters: CompanySpacesUserGroupsUserGroupIdContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssignedContentIndexResponse>>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling companySpacesUserGroupsUserGroupIdContentGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/{user_group_id}/content`.replace(`{${"user_group_id"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssignedContentIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdContentGet(requestParameters: CompanySpacesUserGroupsUserGroupIdContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssignedContentIndexResponse>> {
        const response = await this.companySpacesUserGroupsUserGroupIdContentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdContentIdDeleteRaw(requestParameters: CompanySpacesUserGroupsUserGroupIdContentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling companySpacesUserGroupsUserGroupIdContentIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUserGroupsUserGroupIdContentIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/{user_group_id}/content/{id}`.replace(`{${"user_group_id"}}`, encodeURIComponent(String(requestParameters.userGroupId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdContentIdDelete(requestParameters: CompanySpacesUserGroupsUserGroupIdContentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesUserGroupsUserGroupIdContentIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdContentIdPostRaw(requestParameters: CompanySpacesUserGroupsUserGroupIdContentIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignedContentCreateResponse>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling companySpacesUserGroupsUserGroupIdContentIdPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUserGroupsUserGroupIdContentIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/user_groups/{user_group_id}/content/{id}`.replace(`{${"user_group_id"}}`, encodeURIComponent(String(requestParameters.userGroupId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContentCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssignedContentCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdContentIdPost(requestParameters: CompanySpacesUserGroupsUserGroupIdContentIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignedContentCreateResponse> {
        const response = await this.companySpacesUserGroupsUserGroupIdContentIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdContentIdPutRaw(requestParameters: CompanySpacesUserGroupsUserGroupIdContentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignedContentUpdateResponse>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling companySpacesUserGroupsUserGroupIdContentIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUserGroupsUserGroupIdContentIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/user_groups/{user_group_id}/content/{id}`.replace(`{${"user_group_id"}}`, encodeURIComponent(String(requestParameters.userGroupId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ContentUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssignedContentUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdContentIdPut(requestParameters: CompanySpacesUserGroupsUserGroupIdContentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignedContentUpdateResponse> {
        const response = await this.companySpacesUserGroupsUserGroupIdContentIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersUserIdContentGetRaw(requestParameters: CompanySpacesUsersUserIdContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentParticipationIndexResponse>>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling companySpacesUsersUserIdContentGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.paginatesPer !== undefined) {
            queryParameters['paginates_per'] = requestParameters.paginatesPer;
        }

        if (requestParameters.filterByState) {
            queryParameters['filter_by_state'] = requestParameters.filterByState.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/users/{user_id}/content`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentParticipationIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesUsersUserIdContentGet(requestParameters: CompanySpacesUsersUserIdContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentParticipationIndexResponse>> {
        const response = await this.companySpacesUsersUserIdContentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersUserIdContentIdGetRaw(requestParameters: CompanySpacesUsersUserIdContentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentParticipationShowResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling companySpacesUsersUserIdContentIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUsersUserIdContentIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/users/{user_id}/content/{id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentParticipationShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersUserIdContentIdGet(requestParameters: CompanySpacesUsersUserIdContentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentParticipationShowResponse> {
        const response = await this.companySpacesUsersUserIdContentIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersUserIdContentIdReassignPostRaw(requestParameters: CompanySpacesUsersUserIdContentIdReassignPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentParticipationReassignResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling companySpacesUsersUserIdContentIdReassignPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUsersUserIdContentIdReassignPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/users/{user_id}/content/{id}/reassign`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContentReassignToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentParticipationReassignResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersUserIdContentIdReassignPost(requestParameters: CompanySpacesUsersUserIdContentIdReassignPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentParticipationReassignResponse> {
        const response = await this.companySpacesUsersUserIdContentIdReassignPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CompanySpacesContentGetOwnershipTypeEnum = {
    Original: 'original',
    Bought: 'bought'
} as const;
export type CompanySpacesContentGetOwnershipTypeEnum = typeof CompanySpacesContentGetOwnershipTypeEnum[keyof typeof CompanySpacesContentGetOwnershipTypeEnum];
/**
 * @export
 */
export const CompanySpacesContentGetContentTypesEnum = {
    Course: 'course',
    Test: 'test',
    Document: 'document',
    BlendedLearning: 'blended_learning',
    Source: 'source',
    CourseApprovalRequest: 'course_approval_request',
    ExternalCertificate: 'external_certificate'
} as const;
export type CompanySpacesContentGetContentTypesEnum = typeof CompanySpacesContentGetContentTypesEnum[keyof typeof CompanySpacesContentGetContentTypesEnum];
